var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("h1", [_vm._v("Public")]),
          _vm._v(" "),
          _vm.$userIsTalent
            ? _c("h4", [_vm._v("Browse and apply for engagements")])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCampaign && !_vm.$userIsManager
            ? _c("campaign-notification", {
                attrs: {
                  icon: "bullhorn",
                  title: "1000 Virtual meetings in 100 days",
                  heading:
                    "Help us bring some inspiration to others during this uncertain period...",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn btn-primary",
                              attrs: {
                                to: { name: "kickoffs-with-pickstar.opt-in" },
                              },
                            },
                            [_vm._v("\n            Find out how\n          ")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  467633049
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-results-details" }, [
            _c(
              "div",
              { staticClass: "flex flex-wrap justify-between spacer-b-2" },
              [
                _c("div", { staticClass: "count" }, [
                  _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
                  _vm._v(" public requests"),
                ]),
                _vm._v(" "),
                _c("booking-list-sort", {
                  attrs: {
                    "set-filter-mutation": _vm.setFilter,
                    filters: _vm.filters,
                    options: _vm.sortOptions,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "booking-list-filters",
            {
              attrs: {
                "set-filter-mutation": _vm.setFilter,
                filters: _vm.filters,
                "apply-filters": _vm.handleApplyFiltersCallback,
              },
            },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-primary pull-right",
                  attrs: {
                    slot: "button",
                    click: _vm.handleApplyFiltersCallback,
                    type: "submit",
                    disabled: _vm.$userIsInactiveManager,
                  },
                  slot: "button",
                },
                [_vm._v("\n          Search\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.fetchingBillboardBookings
            ? _c("pickstar-loading", { staticClass: "m-t-lg" })
            : [
                _vm.$userIsInactiveManager
                  ? _c("no-results", { staticClass: "text-center" }, [
                      _c(
                        "div",
                        [
                          _vm._v(
                            "\n            You will be able to view the billboard once " +
                              _vm._s(_vm.clientName) +
                              " has approved your account. In the meantime,\n            build out your "
                          ),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "profile.show" } } },
                            [_vm._v("profile")]
                          ),
                          _vm._v(" or start\n            "),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "talent.index" } } },
                            [
                              _vm._v(
                                "adding your " +
                                  _vm._s(_vm.$starLabelPlural) +
                                  " for review!"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm.$userIsPending
                  ? _c("no-results", { staticClass: "text-center" }, [
                      _c(
                        "div",
                        [
                          _vm._v(
                            "\n            You will be able to view the billboard once Pickstar has approved your account. In the meantime, build out your "
                          ),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "profile.show" } } },
                            [_vm._v("profile")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm.haveNoBillboardBookings
                  ? _c("no-results", { staticClass: "text-center" }, [
                      _c("div", [
                        _vm._v("There are no bookings on the billboard."),
                      ]),
                      _vm._v(" "),
                      _vm.haveAppliedFilters
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-sm m-t-sm",
                              on: { click: _vm.handleResetFiltersCallback },
                            },
                            [_vm._v("Reset Filters")]
                          )
                        : _vm._e(),
                    ])
                  : _c(
                      "ul",
                      { staticClass: "list-items" },
                      _vm._l(_vm.bookings, function (booking) {
                        return _c("billboard-list-item", {
                          key: booking.id,
                          attrs: { booking: booking },
                        })
                      }),
                      1
                    ),
                _vm._v(" "),
                !_vm.$userIsInactiveManager
                  ? _c(
                      "lazy-loading",
                      {
                        ref: "lazyLoading",
                        staticClass: "text-center",
                        attrs: {
                          loading: _vm.loading,
                          "reached-bottom":
                            _vm.handleGetNextBillboardBookingsCallback,
                        },
                      },
                      [
                        _c("pickstar-loading", {
                          attrs: { slot: "loading" },
                          slot: "loading",
                        }),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "finished" },
                          slot: "finished",
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }